import tenantStack from '@Apis/tenantStack.api';

const stackEp = () => '/device/stack/greengrass';

export const stackCreateGreengrass = () => {
	const endpoint = `${stackEp()}/create`;
	return tenantStack.post(endpoint, {});
};

export const stackCheckGreengrass = () => {
	const endpoint = `${stackEp()}/check`;
	return tenantStack.get(endpoint);
};
